import {
  PdfGen,
  PdfUnit,
  PdfSize,
  PdfRect,
  PdfPoint,
  PdfFont,
  PdfBrush,
  ETextAlign,
  PageGen,
} from '../../pdf/pdf';
import { ILayoutLabelTextGen } from '../layoutLabelText';
import { OptsLabelText } from '../optsLabelText';
import { GUtil } from '../../pdf/gutil';
import { IItemCount } from '@educraft/base';
import '../../pdf/draw/primitives';
import '../../pdf/draw/string';
import '../../pdf/draw/image';
import '../../pdf/draw/label';
import '../../pdf/draw/cut';

/**
 * Inicialy__1 - Large initial letter + image
 *
 * Layout: Multiple portrait pages, 2×5 grid per page.
 * Each cell has a large colored initial letter on the left and image on the right.
 *
 * Migrated from C# EduFrame.Img10.Generators.Inicialy__1
 */
export class Inicialy__1 implements ILayoutLabelTextGen, IItemCount {
  countDefault(): number {
    return 10;
  }
  countMin(): number {
    return 1;
  }
  countMax(): number {
    return 50;
  }

  public async generate(pdf: PdfGen, opts: OptsLabelText): Promise<void> {
    const itemsPerPage = 10;
    const pagesNeeded = Math.ceil(opts.list.length / itemsPerPage);
    const pages: PageGen[] = [];
    for (let i = 0; i < pagesNeeded; i++) {
      pages.push(pdf.addPage());
    }

    const margin = PdfUnit.FromMillimeters(5);
    const off = PdfUnit.FromMillimeters(20);
    const cellWidth = PdfSize.A4.width / 2;
    const cellHeight = PdfSize.A4.height / 5;

    const palettes: string[][] = [
      [
        '#7cbfc3',
        '#93c6b1',
        '#a8cc9d',
        '#bdd286',
        '#d1d769',
        '#e0d258',
        '#e8c35a',
        '#f0b45b',
        '#f6a45d',
        '#fb945d',
      ],
      [
        '#b67cc4',
        '#a593c6',
        '#9eb6cc',
        '#87d2d2',
        '#6bd7c0',
        '#5ae0ae',
        '#5ce89d',
        '#5df08c',
        '#5ff67b',
        '#5ffb6b',
      ],
      [
        '#f3da7c',
        '#f1cd89',
        '#eec194',
        '#ebb49e',
        '#e9a7a6',
        '#e699ae',
        '#e38bb4',
        '#df7cbb',
        '#dc6dc0',
        '#d85bc5',
      ],
    ];

    const colors = GUtil.randomBrushes(opts.data.random, palettes);
    const font = new PdfFont(PdfFont.BOLD_FONT_NAME, 165);

    for (let pageIndex = 0; pageIndex < pagesNeeded; pageIndex++) {
      const page = pages[pageIndex];
      const pageStartIndex = pageIndex * itemsPerPage;

      for (let x = 0; x < 2; x++) {
        for (let y = 0; y < 5; y++) {
          const index = pageStartIndex + x * 5 + y;
          if (index >= opts.list.length) continue;

          const rect = new PdfRect(x * cellWidth, y * cellHeight, cellWidth, cellHeight);
          const rect1 = new PdfRect(
            rect.x + margin,
            rect.y + margin,
            rect.width - 2 * margin,
            rect.height - 2 * margin
          );
          const rect2 = new PdfRect(rect1.x + off, rect1.y, rect1.width - off, rect1.height);

          page.drawRectangle(GUtil.cutPen, null, rect);
          page.drawLabel(opts.list[index].label, { rect: rect2 });

          const ini = opts.list[index].text.substring(0, 1).toUpperCase();
          page.drawString(ini, font, colors[x * 5 + y], null, rect1, ETextAlign.CenterLeft);
        }
      }
    }
  }
}
